var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutubeBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M18.977 7.372a2.426 2.426 0 0 0-2.058-1.943c-2.4-.229-4.8-.229-7.2-.229s-4.8 0-7.2.229A2.434 2.434 0 0 0 .343 7.372 20.559 20.559 0 0 0 0 11.945a20.559 20.559 0 0 0 .343 4.573A2.426 2.426 0 0 0 2.4 18.461c2.4.229 4.8.229 7.316.229s4.8 0 7.2-.229a2.426 2.426 0 0 0 2.058-1.943 20.559 20.559 0 0 0 .343-4.573 20.559 20.559 0 0 0-.34-4.573zm-11.2 7.2V9.316l4.8 2.629z",
    transform: "translate(2.571 -.057)",
    style: {
      opacity: 0.4,
      fill: "#191919"
    },
    "data-name": "\\uADF8\\uB8F9 164269"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeBlack);
export default __webpack_public_path__ + "static/media/youtube-black.76c53dc9afbdce3aba504fb8682dffe6.svg";
export { ForwardRef as ReactComponent };